import React, { Component } from "react";
import PropTypes from "prop-types";
import { SortableContainer, arrayMove } from "react-sortable-hoc";

// Locals
import CouImageThumbnails from "./CouImageThumbnails";

// Const
const SortableCouImageThumbnails = SortableContainer(CouImageThumbnails);

// ------------------------------
// CouImagePreview
// ------------------------------
class CouImagePreview extends Component {
  onSortEnd = ({ oldIndex, newIndex }) => {
    const { files, handleChange } = this.props;
    const nextFiles = arrayMove(files, oldIndex, newIndex);
    handleChange(nextFiles);
  };

  onDelete = index => {
    const { files, handleChange } = this.props;
    const nextFiles = files;
    nextFiles.splice(index, 1);
    handleChange(nextFiles);
  };

  onCaptionChange = (index, newCaption) => {
    const { files, handleChange } = this.props;
    const nextFiles = files;
    const obj = files[index];
    obj.caption = newCaption;
    nextFiles[index] = obj;
    handleChange(nextFiles);
  };

  render() {
    const { multiple } = this.props;

    return (
      <div className="CouImagePreview">
        <SortableCouImageThumbnails
          onSortEnd={this.onSortEnd}
          useDragHandle={multiple}
          onCaptionChange={this.onCaptionChange}
          onDelete={this.onDelete}
          {...this.props}
        />
      </div>
    );
  }
}

CouImagePreview.defaultProps = {
  multiple: true
};

CouImagePreview.propTypes = {
  handleChange: PropTypes.func.isRequired,
  files: PropTypes.array,
  multiple: PropTypes.bool
};

export default CouImagePreview;
